// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"a6ab8423","221":"f39b86c7","347":"5d32a299","453":"2cab7a3f","454":"420c9b30","550":"3e658f0d","570":"3dd2a89e","804":"152c1bcf","836":"1c89895b","848":"2e414ce4","986":"770370b0"}[chunkId] + ".chunk.js";
};